/**
 * Coure.Hub.Service.Creation
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ChannelType } from './channelType';
import { ServiceBillingMode } from './serviceBillingMode';
import { ServiceCreationStatus } from './serviceCreationStatus';
import { SubscriptionType } from './subscriptionType';

export interface CreateVasServiceDto { 
    runTime?: number;
    serviceName?: string;
    serviceDescription?: string;
    serviceBillingMode?: ServiceBillingMode;
    channel?: ChannelType;
    serviceFee?: number;
    category?: string;
    shortCode?: string;
    subcriptionType?: SubscriptionType;
    frequency?: number;
    keyword?: string;
    activeDate?: Date;
    expiryDate?: Date;
    dateCreated?: Date;
    status?: ServiceCreationStatus;
    serviceProviderId?: string;
    industryId?: string;
    ussdCampaignId?: string;
    isCallback?: boolean;
    callbackUrl?: string;
}